/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// actions
import { attachLabelToEmbed, setEmbedCardLabels } from 'state/actions/embedsState/embeds_status';
// component
import EditLabels from 'material/embeds/editlabels/editlabels';



/* ========== ~~~~~~~~~~ EDIT LABELS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    labels: embedsState.embedsStatus.labels,
    accountUUID: sessionStatus.accountUUID,
    clientEmbeds: embedsState.embedsStatus.clientEmbeds,
});
// map actions
const mapDispatchToProps = dispatch => ({
    attachLabelToEmbed: (accountUUID, embedUUID, attachedLabels) => dispatch(attachLabelToEmbed(accountUUID, embedUUID, attachedLabels)),
    setEmbedCardLabels: (embedUUID, labelUUIDs) => dispatch(setEmbedCardLabels(embedUUID, labelUUIDs)),

});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(EditLabels));
